import { render, staticRenderFns } from "./PushApplicationsRowItem.vue?vue&type=template&id=0f2555ea&"
import script from "./PushApplicationsRowItem.vue?vue&type=script&lang=ts&"
export * from "./PushApplicationsRowItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports